import { useContext } from 'react';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';

const TagFilterWrapper = ({ children }) => {
  const {
    filters: {
      tag: { availableTags },
    },
  } = useContext(DiscoveryContext);

  const isTagFilterVisible = !!availableTags?.length;

  return children({ isTagFilterVisible });
};

export default TagFilterWrapper;
